var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSync(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.127,
    height: 18.121,
    viewBox: "0 0 22.3 18.121",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a-i-sync{fill:none;stroke:#232323;stroke-linecap:round;stroke-miterlimit:10;stroke-width:1.5px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-95.75 -194.439)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "a-i-sync",
    x1: 3,
    y2: 3,
    transform: "translate(105.5 195.5)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a-i-sync",
    x1: 3,
    y1: 2,
    transform: "translate(105.5 198.5)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a-i-sync",
    x2: 3,
    y2: 2,
    transform: "translate(105.5 206.5)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a-i-sync",
    y1: 3,
    x2: 3,
    transform: "translate(105.5 208.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a-i-sync",
    d: "M106.5,198.5h6.278a5.381,5.381,0,0,1,5.381,5.381h0a5.381,5.381,0,0,1-5.381,5.381h-.925",
    transform: "translate(-1.032 -0.309)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a-i-sync",
    d: "M108.159,209.262h-6.278a5.381,5.381,0,0,1-5.381-5.381h0a5.381,5.381,0,0,1,5.381-5.381h.9",
    transform: "translate(0 -0.309)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSync);
export default __webpack_public_path__ + "static/media/sync.6918c5f0.svg";
export { ForwardRef as ReactComponent };